import React from "react";
import { Plane } from "lucide-react";
import VerticalPage from "@/pages/VerticalPage";

const TYPE_OPTIONS = [
  { value: "flight",  label: "Flight" },
  { value: "train",   label: "Train" },
  { value: "bus",     label: "Bus" },
  { value: "car",     label: "Road trip" },
  { value: "cruise",  label: "Cruise" },
  { value: "hotel",   label: "Hotel" },
  { value: "other",   label: "Other" },
];

export default function Travel() {
  return (
    <VerticalPage
      title="Travel"
      subtitle="Trips, tickets, itineraries"
      endpoint="/travel"
      singularType="travel"
      icon={Plane}
      colorClass="text-indigo-500 bg-indigo-500/12"
      emptySubtitle="Save every booking — flights, hotels, itineraries — next to your travel documents."
      typeField={{ name: "travel_type", label: "Type", options: TYPE_OPTIONS }}
      sections={[
        {
          title: "Trip",
          fields: [
            { name: "title",       label: "Trip name",  type: "text", placeholder: "e.g. Bali family trip", required: true, colSpan: 2 },
            { name: "destination", label: "Destination",type: "text", placeholder: "e.g. Denpasar" },
            { name: "provider",    label: "Provider",   type: "text", placeholder: "e.g. IndiGo, Marriott" },
            { name: "start_date",  label: "Start",      type: "date", postName: "trip_start_date" },
            { name: "end_date",    label: "End",        type: "date", postName: "trip_end_date" },
            { name: "booking_ref", label: "Booking ref / PNR", type: "text", placeholder: "e.g. 6E1234", colSpan: 2 },
          ],
        },
        {
          title: "Notes",
          fields: [
            { name: "notes", label: "Notes", type: "textarea", placeholder: "Itinerary highlights, meeting points", colSpan: 2 },
          ],
        },
      ]}
      formatMeta={(it) => {
        const typeLbl = TYPE_OPTIONS.find((o) => o.value === it.travel_type)?.label;
        const line1 = [typeLbl, it.destination].filter(Boolean).join(" · ");
        const dates = [it.start_date, it.end_date].filter(Boolean).join(" → ");
        const line2 = [dates, it.booking_ref && `PNR ${it.booking_ref}`].filter(Boolean).join(" · ");
        return { line1, line2 };
      }}
    />
  );
}
